export default [
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: () => import('@/views/forgotPassword/index.vue'),
    meta: { pageName: 'forgotPassword', actionName: 'forgotPassword' }
  }
]
